const clg = require('./node_modules/crossword-layout-generator/src/layout_generator.js')

const createSVG = (target, layout) => {
    console.log('SVG', target, layout)

    const createContent = (withClues = false) => {
        const svg = document.createElement('svg')
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
        svg.setAttribute('viewbox', `-0.5 -0.5 ${width} ${height}`)
        svg.setAttribute('width', width)
        svg.setAttribute('height', height)

        const style = document.createElement('style')
        style.setAttribute('type', 'text/css');

        style.innerHTML = `
    g rect {
        fill:#ffffff;
        stroke-width:1.0;
        stroke:#000001;
        fill-opacity:1;
    }

    .cx-a {
        font-size:14.0px;
        font-family:monospace;
        text-anchor:middle;
        pointer-events:none;
        fill:#000003;
    }
    
    .cx-b, .cx-c {
        font-size:8.0px;
        font-family:monospace;
        pointer-events:none;
        font-weight:bold;
        fill:#000002;
    }
    
    .cx-b {
        text-anchor:end;
    }
    
    .cx-c {
        text-anchor:start;
    }
    `

        svg.appendChild(style)

        let x = 0
        let y = 0
        for (const row of layout.table) {
            x = 0
            for (const cell of row) {
                if (cell === '-') {
                    x++
                    continue
                }
                let gx = x * 30
                let gy = y * 30

                const g = document.createElement('g')

                const field = document.createElement('rect')
                field.setAttribute('x', gx)
                field.setAttribute('y', gy)
                field.setAttribute('width', '30')
                field.setAttribute('height', '30')

                const content = document.createElement('text')
                content.classList.add('cx-a')
                content.setAttribute('dy', '.28em')
                content.setAttribute('x', gx + 15)
                content.setAttribute('y', gy + 15)
                content.innerText = cell

                const numbers = []

                const words = layout.result.filter(r => r.startx === x+1 && r.starty === y+1)

                for (const w of words) {
                    const number = document.createElement('text')
                    number.classList.add(w.orientation === 'across' ? 'cx-b' : 'cx-c')
                    number.setAttribute('dy', '1em')
                    number.setAttribute('x', gx + (w.orientation === 'across' ? 28 : 2))
                    number.setAttribute('y', gy + (w.orientation === 'across' ? 2 : 18))
                    number.innerText = allWords.findIndex(w2 => w2 === w.answer) + 1

                    numbers.push(number)
                }

                g.appendChild(field)
                if (withClues) {
                    g.appendChild(content)
                }
                for (const number of numbers) {
                    g.appendChild(number)
                }

                svg.appendChild(g)
                x++
            }
            y++
        }

        return svg.outerHTML
    }

    const allWords = layout.result.map(r => r.answer)
    const allQuestions = layout.result.map(r => r.clue)

    const width = layout.cols * 30 + 2
    const height = layout.rows * 30 + 2

    target.innerHTML = createContent(false)
    document.getElementById('svg2').innerHTML = createContent(true)

    const wordlist = document.createElement('table')
    let i = 1
    for (const word of allQuestions) {
        const tr = document.createElement('tr')
        const l = document.createElement('th')
        const r = document.createElement('td')

        l.innerText = i
        r.innerText = word

        tr.appendChild(l)
        tr.appendChild(r)
        wordlist.appendChild(tr)
        i++
    }

    document.getElementById('wordlist').appendChild(wordlist)
}

window.addEventListener('load', () => {
    const form = document.querySelector('form')
    const result = document.querySelector('#crossword')
    const svgContainer = document.querySelector('#svg')

    /*
    const saved = localStorage.getItem('table')
    if (saved) {
        result.innerHTML = saved
    }
    */

    const savedLayout = localStorage.getItem('layout')
    if (savedLayout) {
        createSVG(svgContainer, JSON.parse(savedLayout))
    }

    form.addEventListener('submit', e => {
        e.preventDefault()

        document.getElementById('wordlist').innerHTML = ''
        svgContainer.innerHTML = ''

        ;(() => {
                const textarea = form.querySelector('textarea')
                const input = textarea.value.trim()

                const data = input.split("\n").reduce((res, line) => {
                    let word = ''
                    while(true) {
                        word += line.substr(0, 1)
                        line = line.substr(1)
                        if (word.trim().length < word.length) {
                            break
                        }
                        if (line.length === 0) {
                            break
                        }
                    }
                    res.push({
                        answer: word.trim(),
                        clue: line.trim(),
                    })
                    return res
                }, [])

                const layout = clg.generateLayout(data);

                localStorage.setItem('layout', JSON.stringify(layout))

                createSVG(svgContainer, layout)

                /*
                const allWords = layout.result.map(r => r.answer)
                console.log('all', layout)

                const t = document.createElement('table')
                let x = 0, y = 0
                for (const row of layout.table) {
                        y++
                        x = 0
                        const r = document.createElement('tr')
                        for (const cell of row) {
                                x++
                                const c = document.createElement('td')
                                c.setAttribute('style', `width: calc((100% / ${layout.table[0].length}) + 2px)`)
                                if (cell !== '-') {
                                    c.classList.add('has-letter')

                                    c.setAttribute('data-letter', cell)

                                    const words = layout.result.filter(r => r.startx === x && r.starty === y)
                                    for (const w of words) {
                                        const span = document.createElement('span')
                                        span.classList.add(w.orientation)
                                        span.innerText = allWords.findIndex(w2 => w2 === w.answer)
                                        c.appendChild(span)
                                    }
                                }
                                r.appendChild(c)
                        }
                        t.appendChild(r)
                }

                result.appendChild(t)
                localStorage.setItem('table', result.innerHTML)
                */
        })()
    })
})

/*
const input_json = [{"clue":"that which is established as a rule or model by authority, custom, or general consent","answer":"standard"},{"clue":"a machine that computes","answer":"computer"},{"clue":"the collective designation of items for a particular purpose","answer":"equipment"},{"clue":"an opening or entrance to an inclosed place","answer":"port"},{"clue":"a point where two things can connect and interact","answer":"interface"}]

console.log(clg)
*/
